import { setSessionData,getToken,getSessionData } from '@/utils/commonApi'
(function () {
    const eduConfigInfo = {
        // theme:getSessionData('configInfo').theme||'element-variables',
        // commonIndex:getSessionData('configInfo').commonIndex||'index'
    };
    if(!getToken()){
        // sessionStorage.setItem("token", "eb8ce71e8ac3413e8211b9c135ecb2dc");
        sessionStorage.setItem("token", "");
    }
    sessionStorage.setItem("configInfo", JSON.stringify(eduConfigInfo));

    // import(`@/assets/styles/${eduConfigInfo.theme}.scss`)
    // import(`@/assets/testStyle/${eduConfigInfo.commonIndex}.scss`)
})();
